import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const billingPersonalizationEnabled = isFeature('billing-personalization-enabled');
